import type { ThemeConfig } from "antd";

/**
 * Ant Design 5+ / 6 的主题 token（等价于昔日 Less modifyVars）。
 * https://ant.design/docs/react/customize-theme-cn
 */
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: "#2B5AED",
    borderRadius: 8,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
  },
  components: {
    Button: {
      primaryShadow: "none",
    },
    Tabs: {
      inkBarColor: "#1A1A1A",
      itemSelectedColor: "#1A1A1A",
      itemHoverColor: "#1A1A1A",
    },
  },
};
